<template>
  <div class="row user">
    <div class="col-md-12">
      <div class="profile">
        <div class="info">
          <img class="user-img" src="../assets/logo.png" />
          <h4>{{ user.name }}</h4>
          <p>{{ user.position }}</p>
        </div>
        <div class="cover-image"></div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="tile p-0">
        <ul class="nav flex-column nav-tabs user-tabs">
          <li class="nav-item">
            <a class="nav-link active" href="#user-timeline" data-toggle="tab"
              >ProfileInformation</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#user-settings" data-toggle="tab"
              >Password Update</a
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-9">
      <div class="tab-content">
        <div class="tab-pane active" id="user-timeline">
          <div class="timeline-post">
            <h4>ProfileInformation</h4>
            <div class="form-group">
              <label for="">Image</label>
              <input type="file" class="form-control" placeholder="" />
            </div>
            <div class="form-group">
              <label for="">Name</label>
              <input type="text" class="form-control" placeholder="" />
            </div>
            <div class="form-group">
              <label for="">Email</label>
              <input type="text" class="form-control" placeholder="" />
            </div>
          </div>
        </div>
        <div class="tab-pane active" id="user-timeline">
          <div class="timeline-post">
            <h4>Password Update</h4>
            <div class="form-group">
              <label for="">Current Password</label>
              <input type="text" class="form-control" placeholder="" />
            </div>
            <div class="form-group">
              <label for="">New Password</label>
              <input type="text" class="form-control" placeholder="" />
            </div>
            <div class="form-group">
              <label for="">Confirm Password</label>
              <input type="text" class="form-control" placeholder="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: this.$store.state.Auth.user.user,
    };
  },
};
</script>

<style>
</style>